import renderSelect from 'components/FormControls/select'
import { Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { Field } from 'redux-form'
import formatMoney, { formatToString } from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'

export const Wallets = ({
  wallets = null,
  walletsLoading = false,
  loading = false,
  t = () => {},
  className = '',
  label = 'wallet',
  showEmptyOption = undefined,
  emptyOptionLabel = null,
  ...rest
}) => {
  if (!wallets) {
    return null
  }

  const walletsOptions = useMemo(() => {
    if (wallets?.length === 0) {
      return []
    }

    return wallets.map(
      ({
        currency,
        balance,
        id = undefined,
        financial_profile: { financial_profile_type: { type = null } = {}, custom_name },
      }) => ({
        label: custom_name ?? t(`wallets::types.${type}`),
        balance,
        currency,
        value: id === undefined ? currency : id === null ? 'null' : id,
      }),
    )
  }, [wallets, t])

  return (
    <div className={className}>
      <Field
        name="wallet_id"
        options={walletsOptions}
        fullWidth
        className={styles['billing__select']}
        showEmptyOption={
          showEmptyOption !== undefined ? showEmptyOption : !loading && walletsOptions.length !== 0
        }
        readOnly={loading || walletsOptions.length === 0}
        label={t(label)}
        t={t}
        emptyOptionLabel={emptyOptionLabel || t('form.wallet_id.options.empty')}
        clearOptionLabel={t('common::select_clear_option')}
        component={renderSelect}
        activeOptionLabelTemplate={({ balance, currency }) => formatToString(balance, currency)}
        optionLabelTemplate={({ label, balance, currency }) => (
          <div
            dangerouslySetInnerHTML={{
              __html: `
              <div>
                <div class="${styles['billing__select-option-value']}">${formatMoney(
                balance,
                currency,
              )}</div>
                <div class="${styles['billing__select-option-sub-value']}">
                ${t(label)}</div>
              </div>`,
            }}
          />
        )}
        ControlProps={{
          startAdornment: walletsLoading ? (
            <Spinner
              width={16}
              color={'Label-GU-Primary'}
            />
          ) : null,
        }}
        {...rest}
      />
    </div>
  )
}

Wallets.propTypes = {
  className: PropTypes.string,
  wallets: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
  loading: PropTypes.bool,
  t: PropTypes.func,
  walletsLoading: PropTypes.bool,
  label: PropTypes.string,
  showEmptyOption: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  emptyOptionLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
}
